/**
 * Combines styles together, removes falsy values, duplicates and useless spaces.
 * @example
 * ```tsx
 * import { st } from "@/utils";
 * import styles from "./myStyles.module.scss";
 *
 * <div
 *  className={st("one", "two", undefined, "three four")}
 * >
 *  Hello
 * </div>; // returns "one two three four" global classes
 *
 * <div
 *  className={st(styles.one, styles.two, undefined, styles.three, style.three, styles.four)}
 * >
 *  GoodBye
 * </div>; // returns "one two three four" classes from myStyles.module.scss
 *
 * <div
 *  className={st(false && "one", true && "two")}
 * >
 *  Hello again
 * </div>; // returns "two" only
 * ```
 */
export function st(...classes: (string | false | undefined | null)[]) {
  // removes all falsy values: undefined, null, false and empty strings
  const truthyClasses = classes.filter((c) => c) as string[];

  // removes all matter of spaces throughout strings
  const cleanedUpClasses = truthyClasses
    .join(" ")
    .split(" ")
    .filter((c) => c);

  // removes duplicates
  return Array.from(new Set(cleanedUpClasses)).join(" ");
}
